const CTA_META = {
  schedule_visit: {
    label: 'Agendar visita',
    icon: 'i-lucide-calendar-plus',
    variant: 'primary',
  },
  contact_advertiser: {
    label: 'Contatar anunciante',
    icon: 'i-lucide-message-circle',
    variant: 'ghost',
  },
  notify_when_available: {
    label: 'Avisar quando disponível',
    icon: 'i-lucide-bell-plus',
    variant: 'ghost',
  },
  similar_properties: {
    label: 'Ver similares',
    icon: 'i-lucide-building-2',
    variant: 'ghost',
  },
};

const normalizeAction = value =>
  String(value || '')
    .trim()
    .replace(/[-\s]/g, '_')
    .toLowerCase();

const normalizeCta = (cta, slot) => {
  const action = normalizeAction(cta?.action || cta?.type || cta?.kind);
  const meta = CTA_META[action];
  if (!meta) return null;

  return {
    slot,
    action,
    label: cta?.label || meta.label,
    icon: cta?.icon || meta.icon,
    variant: cta?.variant || meta.variant,
  };
};

const fromPresenter = listing => {
  const primary = normalizeCta(listing?.cta?.primary, 'primary');
  const secondary = normalizeCta(listing?.cta?.secondary, 'secondary');
  return [primary, secondary].filter(Boolean);
};

const statusValue = listing =>
  String(
    listing?.listingStatus ||
      listing?.listing_status ||
      listing?.status ||
      listing?.availabilityStatus ||
      ''
  ).toLowerCase();

const visitsAllowed = listing => {
  const value =
    listing?.visitasPermitidas ??
    listing?.visitsAllowed ??
    listing?.visit_allowed ??
    listing?.visits_allowed;
  return value !== false;
};

const isUnavailable = listing => {
  const status = statusValue(listing);
  return [
    'despublicado',
    'suspenso',
    'suspended',
    'indisponivel',
    'indisponível',
    'unavailable',
    'housenotavailable',
    'house_not_available',
  ].some(token => status.includes(token));
};

const isOptedOut = listing => statusValue(listing).includes('opted');

const action = (name, slot) => normalizeCta({ action: name }, slot);

export const resolveListingCtas = listing => {
  const presenterCtas = fromPresenter(listing);
  if (presenterCtas.length) return presenterCtas;

  if (isOptedOut(listing)) {
    return [action('similar_properties', 'primary')];
  }

  if (isUnavailable(listing)) {
    return [
      action('notify_when_available', 'primary'),
      action('similar_properties', 'secondary'),
    ];
  }

  if (!visitsAllowed(listing)) {
    return [
      action('contact_advertiser', 'primary'),
      action('similar_properties', 'secondary'),
    ];
  }

  return [
    action('schedule_visit', 'primary'),
    action('contact_advertiser', 'secondary'),
  ];
};

export default resolveListingCtas;
